import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';

@UntilDestroy()
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  user: any;
  showCompany: any = false;
  driverCount: any;
  vehicleCount: any;
  companyDetail:any;
  companyObj:any;
  drivers:any;
  vehicles:any;
  companyWiseConfiguration:any;
  companyId: any;
  constructor(private sharedDataService : SharedDataService,
    private credentialService :CredentialService

  ){}

  ngOnInit(): void {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
    .getUser()
      .pipe(untilDestroyed(this))
    .subscribe(user => {
      if (user) {
        this.user = user;
        this.companyId = this.user?.company?.id;
        this.getCompanybyId();
        this.getDashboardDetail();
        this.getConfigurationbyId();
      }
    });
  }

  getCompanybyId() {
    this.credentialService.getCompanyById(this.user.company.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
       this.companyDetail = data; 
      }
    })
  }

  getDashboardDetail() {
    this.credentialService.getDashboardDetails(this.user.company.id).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
       this.driverCount = data.drivers;
       this.vehicleCount = data.vehicles;

      }
    })
  }

  getConfigurationbyId() {
  this.credentialService.getConfigByCompanyWise(this.companyId)
    .pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data) {
        this.companyWiseConfiguration = data
      }
    });
  }



  openCompanyOverview(data: any) {
    this.companyObj = data
    this.drivers = this.driverCount
    this.vehicles = this.vehicleCount
  }

  ngOnDestroy(): void { }
}
